import { Component, Input } from '@angular/core';
import { LowerCasePipe, NgClass, NgForOf } from '@angular/common';
import { Company, CompanyEnum } from '../../models/company.model';

@Component({
  selector: 'lx-price-lists-portal-application-form',
  standalone: true,
  imports: [LowerCasePipe, NgClass, NgForOf],
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss'],
})
export class ApplicationFormComponent {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() applicationForms = [];
}
